import { render } from "./theme18.vue?vue&type=template&id=06cbcc50&scoped=true"
import script from "./theme18.vue?vue&type=script&lang=js"
export * from "./theme18.vue?vue&type=script&lang=js"

import "./theme18.vue?vue&type=style&index=0&id=06cbcc50&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-06cbcc50"

export default script